import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getReceiveSummary } from '@/service/operate/comprehensiveDaily';
export default function useReceiveSummary(params) {
  var receiveSummary = ref({
    aggregateReleaseNums: 0,
    commercialTaxMoney: 0,
    mortarTaxMoney: 0,
    commercialReleaseNums: 0,
    mortarReleaseNums: 0,
    aggregateTaxMoney: 0
  });
  // 查询时间范围内停机详情
  var getReceiveSummaryAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getReceiveSummary(params.value);
          case 2:
            data = _context.sent;
            receiveSummary.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getReceiveSummaryAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  //领用数据
  var receiveData = computed(function () {
    return [{
      money: receiveSummary.value.aggregateTaxMoney,
      amount: receiveSummary.value.aggregateReleaseNums,
      desc: '骨料'
    }, {
      money: receiveSummary.value.commercialTaxMoney,
      amount: receiveSummary.value.commercialReleaseNums,
      desc: '商砼'
    }, {
      money: receiveSummary.value.mortarTaxMoney,
      amount: receiveSummary.value.mortarReleaseNums,
      desc: '砂浆'
    }];
  });
  return [receiveData, getReceiveSummaryAsync];
}